export default [
    {
    "type": "staff",
    "name": "Carolina Huffmann",
    "org": "Urbanismo Vivo",
    "picture": "carolinahuffman.jpg",
    "instagram": "carohuffmann",
    "twitter": "CaroHuffmann",
    "facebook": null,
    "bio": ""
  },
    {
    "type": "staff",
    "name": "Doménico Di Siena",
    "org": "CivicWise", 
    "picture": "domenicodisiena.jpg",
    "instagram": "urbanohumano",
    "twitter": "urbanohumano",
    "facebook": "urbanohumano",
    "bio": ""
  },
    {
    "type": "staff",
    "name": "Matias Lastra",
    "org": "Urbanismo Vivo",
    "picture": "matiaslastra.jpg",
    "instagram": 'matilast',
    "twitter": null,
    "facebook": null,
    "bio": ""
  },
    {
    "type": "staff",
    "name": "Victor Franco López",
    "org": "Colectiva Habitaria",
    "picture": "victorfranco.jpg",
    "instagram": "victorfrancolopez",
    "twitter": "_victor_franco",
    "facebook": "victor.francolopez.90",
    "bio": ""
  },
    {
    "type": "staff",
    "name": "Cecilia Cianco",
    "org": "Urbanismo Vivo",
    "picture": "ceciliacianco.jpg",
    "instagram": "ceciciancio",
    "twitter": "ceci_ciancio",
    "facebook": null,
  },
]